import React, { useEffect } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import AOS from 'aos'
import Homeone from '../components/Homeone/Main'
import AboutUs from '../components/AboutUs/Main'
import Contactus from '../components/Contactus/Main'
import FeaturesPage from '../components/Pages/Features/Main'
import Privacy from '../components/Pages/Privacy/Main'
import Terms from '../components/Pages/Terms/Main'
import Changelog from '../components/Pages/Changelog/Main'

const Index = () => {
  useEffect(() => {
    AOS.init()
    AOS.refresh()
  }, [])

  return (
    <Routes>
      <Route path="/" element={<Homeone />} />
      <Route path="/features" element={<FeaturesPage />} />
      <Route path="/contact" element={<Contactus />} />
      <Route path="/Contactus" element={<Navigate to="/contact" replace />} />
      <Route path="/privacy-policy" element={<Privacy />} />
      <Route path="/terms-of-use" element={<Terms />} />
      <Route path="/changelog" element={<Changelog />} />
      <Route path="/aboutus" element={<AboutUs />} />
      <Route path="/AboutUs" element={<Navigate to="/aboutus" replace />} />
      <Route path="/Pricing" element={<Navigate to={{ pathname: '/', hash: '#pricing_sec' }} replace />} />
      <Route path="/pricing" element={<Navigate to={{ pathname: '/', hash: '#pricing_sec' }} replace />} />
      <Route path="/Bloglist" element={<Navigate to="/" replace />} />
      <Route path="/Blogdetail" element={<Navigate to="/" replace />} />
      <Route path="/Blog" element={<Navigate to="/" replace />} />
      <Route path="/Reviews" element={<Navigate to="/" replace />} />
      <Route path="/Signin" element={<Navigate to="/" replace />} />
      <Route path="/Signup" element={<Navigate to="/" replace />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default Index
